module.exports = __webpack_public_path__ + "static/talks3-e38fd6d42250e9eeacde5c8b15355b28.png";